export default "__VITE_ASSET__DsmnfrFL__"